const loggerMixin = {
  methods: {
    log(message) {
      console.log(`${this.$options.name}#${message}`);
    }
  }
};

export {loggerMixin};
